import { useState, useEffect } from 'react'
import { evaluationService } from '@/services/evaluationService'
import type { EvaluationAnalytics } from '@shared/types/evaluation'
import { toast } from 'sonner'

interface UseEvaluationStatsReturn {
  stats: EvaluationAnalytics | null
  loading: boolean
  error: string | null
  refreshStats: () => Promise<void>
}

export const useEvaluationStats = (): UseEvaluationStatsReturn => {
  const [stats, setStats] = useState<EvaluationAnalytics | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchStats = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await evaluationService.getEvaluationStats()
      setStats(data)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch evaluation statistics'
      setError(errorMessage)
      console.error('Error fetching evaluation stats:', err)
      toast.error('Failed to load evaluation statistics')
    } finally {
      setLoading(false)
    }
  }

  const refreshStats = async () => {
    await fetchStats()
  }

  useEffect(() => {
    fetchStats()
  }, [])

  return {
    stats,
    loading,
    error,
    refreshStats
  }
}